import { render, staticRenderFns } from "./TraxUiCardIconHeader.vue?vue&type=template&id=168e899f"
import script from "./TraxUiCardIconHeader.vue?vue&type=script&lang=js"
export * from "./TraxUiCardIconHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports